import React, { useEffect, useRef } from 'react';

const GameMonetizeVideo = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Define options globally as required by the API
    window.VIDEO_OPTIONS = {
      gameid: "4kci7og3klgj0ivy2wz3gdvd9dth5e7n",
      width: "100%",
      height: "480px",
      color: "#3f007e",
      getAds: "false" // Kept as requested, though usually 'true' for monetization
    };

    // Script injection logic
    const scriptId = "gamemonetize-video-api";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://api.gamemonetize.com/video.js";
      script.async = true;
      document.body.appendChild(script);
    } else {
      // If script already exists, the player might need re-initialization logic
      // typically handled by the provider's script automatically looking for the div
    }

    return () => {
      // Cleanup if necessary, though external scripts usually persist
    };
  }, []);

  return (
    <div className="w-full flex justify-center items-center bg-black/20 rounded-xl overflow-hidden p-2">
      <div 
        id="gamemonetize-video" 
        style={{ width: '100%', minHeight: '480px' }}
      ></div>
    </div>
  );
};

export default GameMonetizeVideo;